<template>
    <!-- When Submit a Spot this modal Appears -->
    <div class="modal modal--popup custom-modals sas-loading-modal">
        <div class="modal-overlay"></div>
        <div class="modal__content">
            <div class="new-loader alt-loader">
                <div class="loader-content">
                    <div class="star-wrapper">
                        <svg class="star"><use xlink:href="#star"></use></svg>
                        <svg class="mask"><use xlink:href="#mask-alt"></use></svg>
                    </div>
                </div>
            </div>
            <h2>Gathering your spot's <span id="sas-loading-text">deets...</span></h2>
        </div>
    </div>
</template>
<script>

export default {

    data() {
        return {
            words : ['deets...', 'pics...', 'address...'],
            sasLoadingCounter: 0,
        }
    },

    mounted() {
        setTimeout(this.init, 400)
    },

    methods: {

        init(){
            $('.sas-loading-modal').addClass('is-open');
            $('.sas-loading-modal .new-loader .star-wrapper:not(.animated)').addClass('animated');
            setInterval(this.sasLoadingAnimation, 3000);
        },

        sasLoadingAnimation() {

            $('#sas-loading-text').addClass('fade');

            setTimeout(() => {
                $('#sas-loading-text').text(this.words[this.sasLoadingCounter]);
                $('#sas-loading-text').removeClass('fade');
            }, 500);

            this.sasLoadingCounter++;
            if (this.sasLoadingCounter >= this.words.length) {
                this.sasLoadingCounter = 0
            }
        }
    },
}
</script>
